import { useState } from "react";
import "./CreatePostPermissions.css";

export default function CreatePostPermissions({ value, onChange }) {
  const [open, setOpen] = useState(false);

  const options = [
    { value: "public", label: "Everyone", icon: <i class="fi fi-br-world"></i> },
    { value: "follow", label: "Accounts you follow", icon: <i className="fi fi-rr-user-check"></i> },
    { value: "verified", label: "Verified accounts", icon: <i className="fi fi-sr-shield-trust"></i> },
    { value: "mention", label: "Only accounts you mention", icon: <i className="fi fi-ss-at"></i> },
  ];

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className="cpp-container">
      <button
        className="cpp-trigger"
        onClick={() => setOpen((prev) => !prev)}
      >
        {selectedOption && (
          <>
            <span className="cpp-trigger-icon">{selectedOption.icon}</span>{"  "}
            {selectedOption.label}
          </>
        )}
        <span className="cpp-caret">▾</span>
      </button>

      {open && (
        <div className="cpp-dropdown">
          <div className="cpp-header">
            <p className="cpp-title">Who can reply?</p>
            <p className="cpp-description">
              Set reply permissions for this post. Tagged people will still be able to reply.
            </p>
          </div>
          <div className="cpp-options">
            {options.map((opt) => (
              <div
                key={opt.value}
                className={`cpp-option ${value === opt.value ? "selected" : ""}`}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
              >
                <span className="cpp-option-icon">{opt.icon}</span>{"  "}
                {opt.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
